const state = {
  isDarkMode: localStorage.getItem('darkMode') === 'true' || false
};

const getters = {
  isDarkMode: state => state.isDarkMode
};

function applyDocumentThemeClass(isDark) {
  const targets = [document.body, document.querySelector('.v-application')].filter(Boolean);
  targets.forEach((el) => {
    if (isDark) {
      el.classList.add('dark-mode');
      el.classList.remove('light-mode');
    } else {
      el.classList.remove('dark-mode');
      el.classList.add('light-mode');
    }
  });
}

const mutations = {
  toggleDarkMode(state) {
    state.isDarkMode = !state.isDarkMode;
    localStorage.setItem('darkMode', state.isDarkMode);
    applyDocumentThemeClass(state.isDarkMode);
  },
  
  setDarkMode(state, value) {
    state.isDarkMode = value;
    localStorage.setItem('darkMode', value);
    applyDocumentThemeClass(value);
  }
};

const actions = {
  initializeDarkMode({ commit }) {
    const savedMode = localStorage.getItem('darkMode');
    if (savedMode !== null) {
      commit('setDarkMode', savedMode === 'true');
    } else {
      commit('setDarkMode', false);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
